import Component from '@glimmer/component'
import type SessionService from 'teacher-ui-client/services/session'
import { service } from '@ember/service'
import type Owner from '@ember/owner'
import config from 'teacher-ui-client/config/environment'

export class ZoomWebChat extends Component<unknown> {
  constructor(owner: Owner, args: never) {
    super(owner, args)
    this.setGlobals()
  }

  @service session!: SessionService

  get window(): Window & { zoomchat?: { school?: string } } {
    return window
  }

  get shouldBoot() {
    return config?.zoomChat?.enabled && this.window.zoomchat?.school
  }

  setGlobals() {
    const sessionService = this.session

    window.zoomchat = {}

    Object.defineProperties(window.zoomchat, {
      firstName: {
        configurable: true,
        get() {
          return sessionService.currentTeacher.firstName
        },
      },
      lastName: {
        configurable: true,
        get() {
          return sessionService.currentTeacher.lastName
        },
      },
      email: {
        configurable: true,
        get() {
          return sessionService.currentTeacher.email
        },
      },
      school: {
        configurable: true,
        get() {
          return sessionService.currentSchool.schoolCode
        },
      },
    })
  }
  willDestroy(): void {
    super.willDestroy()

    delete window.zoomchat
  }

  <template>
    {{#if this.shouldBoot}}
      {{! template-lint-disable no-forbidden-elements }}
      <script
        data-apikey="T3LIvabCT2Oi-dqRo6vWXQ"
        data-env="us01"
        src="https://us01ccistatic.zoom.us/us01cci/web-sdk/zcc-sdk.js"
      ></script>
    {{/if}}
  </template>
}
